export default "/_next/static/images/5cf53aec2b71e74678dd84f7654130bc.png";